import { useState, useCallback, type ReactNode } from "react";

import { DocumentLimitError } from "@/shared/utils/uploadDocument";
import { DocumentLimitPaywall } from "@/pages/postloss/documents/components/DocumentLimitPaywall";

export function useDocumentLimitPaywall() {
  const [isOpen, setIsOpen] = useState(false);

  const checkError = useCallback((err: unknown): boolean => {
    if (err instanceof DocumentLimitError) {
      setIsOpen(true);
      return true;
    }
    return false;
  }, []);

  const show = useCallback(() => setIsOpen(true), []);

  const paywall: ReactNode = <DocumentLimitPaywall isOpen={isOpen} onOpenChange={setIsOpen} />;

  return { checkError, show, paywall };
}
